import CharacterCount from './CharacterCount';
export { CharacterCount };
export default CharacterCount;
